const mEditionAssetComments = {
  mEditionAssetComments: {
    messages: {
      noComments: 'Sin comentarios',
      noQuestions: 'Sin preguntas',
      notAnsered: 'Sin Responder'
    },

    quote: {
      firstText: 'Aún no tienes contenidos creados en tu curso.',
      secondText: 'Para interactuar con tus alumnos en la sección de comentarios primero debes crear contenidos ingresando a'
    },

    submenu: {
      comments: 'Comentarios',
      questions: 'Preguntas'
    }
  }
}

export default mEditionAssetComments
